import {Typography} from 'antd';
import React, {Fragment} from 'react';
import {BackButtonWText} from 'Components';

interface IProps {
  image: string;
  data: any;
  resetAfterSubmitting?(): any;
  srId?: number | null;
}
const SubmissionResult: React.FC<IProps> = (props) => {
  const {image, data, resetAfterSubmitting, srId} = props;
  return (
    <div style={{margin: 24, display: 'flex', flexDirection: 'column', height: '40vh'}}>
      <div style={{position: 'absolute'}}>
        <BackButtonWText text={data.back_text} callback={resetAfterSubmitting} />
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          justifyContent: 'center',
          alignItems: 'center',
        }}>
        <img src={image} alt="" />
        <Typography.Title level={5} style={{margin: 16}}>
          {srId ? data.success_text : data.updated_text}
        </Typography.Title>
        {srId && (
          <Fragment>
            <Typography.Text>
              <strong>{data.ticket_text} </strong>
              {srId}
            </Typography.Text>
          </Fragment>
        )}
      </div>
    </div>
  );
};

export default SubmissionResult;
